import { ref, onMounted } from 'vue';
import { useRouter } from "vue-router";
import { useStore } from 'vuex';
import httpRequest from '@/request/index';
import { showFailToast } from 'vant';
export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    let page = ref(1),
      pageSize = ref(10);
    let loading = ref(false),
      finished = ref(false);
    let list = ref([]);
    const loadData = () => {
      httpRequest({
        method: "get",
        url: "?file=news",
        params: {
          limit: pageSize.value,
          page: page.value
        }
      }).then(res => {
        if (res.state == 1) {
          loading.value = false;
          const _list = res.list;
          list.value = [...list.value, ..._list];
          if (_list.length < pageSize.value) {
            finished.value = true;
          }
          page.value++;
        } else {
          showFailToast(res.msg);
        }
      });
    };
    onMounted(async () => {
      await store.dispatch("cklogin").then(() => {
        if (!store.state.isLogin) {
          router.replace("/login");
        }
      });
    });
    const goBack = () => {
      router.go(-1);
    };
    return {
      loading,
      finished,
      list,
      loadData,
      goBack
    };
  }
};